/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { IOas30Expression } from './IOas30Expression';

/**
 * Models an OpenAPI link parameter expression.
 * @author eric.wittmann@gmail.com
 * @extends Node
 * @class
 */
export class Oas30LinkParameterExpression extends Node implements IOas30Expression {
    /*private*/ _name : string;

    /*private*/ _value : string;

    constructor(name : string, value : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this._value===undefined) this._value = null;
        this._name = name;
        this._value = value;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitLinkParameterExpression(this);
    }

    /**
     * Gets the name of the expression.
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30Expression#getValue()
     * @return {string}
     */
    public getValue() : string {
        return this._value;
    }

    /**
     * Returns true if the expression is a dynamic link parameter expression that must be evaluated.
     * @return {boolean}
     */
    public isExpression() : boolean {
        return this.getValue() != null && this.getValue().indexOf("$") === 0;
    }

    /**
     * Returns true if the expression is just a constant value.
     * @return {boolean}
     */
    public isConstant() : boolean {
        return !this.isExpression();
    }
}
Oas30LinkParameterExpression["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression";
Oas30LinkParameterExpression["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.openapi.v3.models.IOas30Expression"];




